// extracted by mini-css-extract-plugin
module.exports = {"label":"_3giCR_0qYxOcKl10heNXbn","sectionHeader":"_2ljXYm6iuTNH9EG1J-J7Jc"};